import * as React from "react";
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    style={{
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd",
    }}
    viewBox="0 0 35770 35770"
    {...props}
  >
    <defs>
      <style>
        {
          // ".str0{stroke:#000;stroke-width:518.407}.fil0{fill:#1c1b17;fill-rule:nonzero}"
        }
      </style>
    </defs>
    <g id="Layer_x0020_1">
      <path
        d="M9018 259h17734c2402 0 4591 986 6181 2573l3 2 3 3c1586 1590 2572 3778 2572 6181v17733c0 2404-987 4594-2575 6185l3 3c-1587 1586-3778 2571-6187 2571H9018c-2409 0-4600-985-6186-2571l2-3c-1588-1591-2575-3781-2575-6185V9018c0-2403 986-4591 2573-6181l2-3 3-2C4427 1245 6616 259 9018 259zm17734 2962H9018c-1596 0-3046 652-4093 1699l-5 6C3873 5972 3222 7422 3222 9018v17733c0 1597 651 3047 1698 4093h5c1051 1050 2501 1704 4093 1704h17734c1592 0 3042-654 4093-1704h5c1048-1046 1698-2496 1698-4093V9018c0-1596-650-3046-1698-4092l-5-6c-1047-1047-2497-1699-4093-1699z"
        className="stroke1 fill"
        style={{
          strokeWidth: 518.407,
          fillRule: "nonzero",
        }}
      />
      <path
        d="M17886 15581c1272 0 2303 1031 2303 2304 0 1272-1031 2303-2303 2303-1273 0-2305-1031-2305-2303 0-1273 1032-2304 2305-2304z"
        className="stroke1 fill"
        style={{
          strokeWidth: 518.407,
        }}
      />
      <path
        d="M25451 11295v3980l-7565-7126-7567 7126v-3980l7567-7126zM25451 24476v-3982l-7565 7126-7567-7126v3982l7567 7125z"
        className="stroke1 fill"
        style={{
          strokeWidth: 518.407,
          fillRule: "nonzero",
        }}
      />
    </g>
  </svg>
);
export default SvgComponent;
